module.exports = __webpack_public_path__ + "img/1325aoa.d7a058c7.png";